import { Dispatcher, IDispatcherEventMap, Log } from "@fanfanlo";
import { ClientEvent, createClient, ICreateClientOpts, MatrixClient, MatrixEventEvent, RoomEvent, RoomMemberEvent, RoomStateEvent, SyncState } from "matrix-js-sdk";
import { ISyncStateData } from "matrix-js-sdk/lib/sync";
import { createMatrixClientProxy } from "./proxy";

const fileLogger = new Log(false, 'im.client');
fileLogger.childrenPaused = true;
fileLogger.pause = true;
let client:MatrixClient;
const imDispatcher = new Dispatcher();
const clientOnEventDispatcher = new Dispatcher();
const clientMethodDispatcher = new Dispatcher();
export interface IMatrixClientEventMap extends IDispatcherEventMap{
    onUserSignin:()=>void
    onUserSignout:()=>void
    onClientDestroyed:(client:MatrixClient)=>void
    onClientCreated:(client:MatrixClient)=>void
    onClientSyncEvent:(data:IMatrixClientSyncData)=>void
}
export type MatrixEventTypes = ClientEvent | IMatrixClientEventMap | RoomEvent | MatrixEventEvent | RoomMemberEvent | RoomStateEvent;
export interface IMatrixClientSyncData{
    state:SyncState
    prevState:SyncState | null
    data?:ISyncStateData
}

export const matrixEventMap = {
    ...ClientEvent,
    ...RoomEvent,
    ...MatrixEventEvent,
    ...RoomMemberEvent,
    ...RoomStateEvent
}

async function createLoginClient(opts:ICreateClientOpts){
    return createClient(opts)
}
async function createProxyClient(opts:ICreateClientOpts){
    if(client){
        imDispatcher.dispatch<MatrixEventTypes>('onClientDestroyed', client)
        client.stopClient();
    }
    opts.timelineSupport = true;
    const c = createClient(opts);
    
    client = createMatrixClientProxy(c, clientMethodDispatcher);

    for(const event of Object.values(matrixEventMap)){
        client.on(event as any,(...args:any[])=>{
            const arr = Array.from(args)
            clientOnEventDispatcher.dispatch<MatrixEventTypes>(event, ...arr)
        })
    }
    imDispatcher.dispatch<MatrixEventTypes>('onClientCreated', client)

    return client;
}
async function init() {
    fileLogger.log('init');

}

export enum ImDispatcherEventTypes{
    INVITE = "invite"
}
export const matrixClient = {
    init,
    // 它在proxy.ts文件里用于代理派发事件，就是要拦截对client的调用的话可以用这个变量。
    // 它代理了client的函数调用，目的是有些地方可以方便地自行调用client而不需要封装，
    // 自行调用虽然方便，但是未来可能造成隐患，所以代理一次后可以在未来有需求时利用这个事件来更改调用参数和结果。
    clientMethodDispatcher,
    // 它代理了client的on事件
    // 因为matrix的client需要多次创建，而每次创建都需要卸载之前的侦听和重新侦听新client的事件，
    // 所以创建了clientOnEventDispatcher这个事件派发器，
    // 用这个来代理派发client的事件，在其它位置只需要侦听clientOnEventDispatcher的事件即可，就不需要响应client的变更去卸载和重新侦听了。
    clientOnEventDispatcher,
    // 当im的自定义事件用它来派发。它派发的事件一定要在IMatrixClientEventMap里进行声明
    // dispatcher可以在没有client的情况下提前侦听事件。
    // 在切换client后也不需要重新侦听，因为proxy那边换client后依然用同一个dispatcher派发事件。
    imDispatcher,
    get client(){
        return client;
    },
    createProxyClient,
    createLoginClient,
    ImDispatcherEventTypes
}